module.exports = __webpack_public_path__ + "img/item2-1.b57689ae.jpg";